import { ComponentType } from 'react';
import { TranslatedItem } from 'src/hooks/directus/useTranslateItem';
import { NeauviaItem } from 'src/models/directus';

export enum MaterialPageTabId {
  Notes = 'NOTES',
  UserNotes = 'USER_NOTES',
  Details = 'DETAILS',
  Products = 'PRODUCTS',
  Episodes = 'EPISODES',
}

export type MaterialPageTab<T extends NeauviaItem = NeauviaItem> = {
  id: MaterialPageTabId;
  description: string;
  title?: string;
  count?: number;
  rendererKey?: string;
  Renderer: ComponentType<{ item: TranslatedItem<T> | undefined }>;
};
